export interface UserProfile {
    accessToken: string;
    refreshToken: string;
    userDetails?: UserDetails
}
export interface UserDetails {
    clientId: number
    createdBy: number
    createdOn: string
    firstName: string | null;
    isActive: any;
    lastnName: string | null;
    licenseId: any;
    middleName: any;
    modifiedBy: number
    modifiedOn: string
    password: string;
    userId: number
    userName: string;
    userRole: number
    userType: number;
    payerId?: number;
    providerId?: number;
    permissions?: string[]
}
